const 公募基金 = [
  {
    name: '高级管理',
    children: ['董事长', '总经理', '督察长', '副总经理', '总经理助理'],
  },
  {
    name: '公募投资',
    children: ['公募投资（综合）', '权益投资', '固收投资', '货币投资', '量化投资', 'QDII投资', 'FOF投资', '指数投资'],
  },
  {
    name: '专户投资',
    children: ['专户投资（综合）', '权益投资', '固收投资', '货币投资', '量化投资', 'FOF投资', '国际投资'],
  },
  {
    name: '年金养老金投资',
    children: ['固收投资'],
  },
  {
    name: '研究',
    children: ['研究（综合）', '债券研究', '量化研究', '基金研究', '宏观研究', '行业研究', '国际研究', '策略研究'],
  },
  {
    name: '资管项目',
    children: ['资管项目投资经理'],
  },
  {
    name: '风险控制',
    children: ['风控'],
  },
  {
    name: '监察稽核',
    children: ['法务', '合规', '内控', '内部审计', '信息披露'],
  },
  {
    name: '销售',
    children: ['机构销售', '渠道销售', '年金养老金销售', '高净值客户销售', '财富管理', '客户服务', '直销柜台'],
  },
  {
    name: '销售支持',
    children: ['综合管理', '渠道', '机构'],
  },
  {
    name: '市场',
    children: ['市场营销', '品牌', '公共关系', '活动策划', '新媒体'],
  },
  {
    name: '行政文秘',
    children: ['业务秘书', '行政', '董事会办公室'],
  },
  {
    name: '财务',
    children: ['综合管理', '会计核算', '预算', '财务管理', '税务', '资金管理'],
  },
  {
    name: '人力资源',
    children: ['人力综合', '组织发展', '薪酬福利', '招聘', '员工关系', '培训', '绩效'],
  },
  {
    name: '信息技术',
    children: ['综合管理', '运营维护', '业务分析', '开发'],
  },
  {
    name: '战略发展',
    children: ['战略研究'],
  },
  {
    name: '交易',
    children: ['综合管理', '固定收益', '股票交易'],
  },
  {
    name: '基金运营',
    children: ['综合管理', '基金清算', '基金会计', '注册登记'],
  },
  {
    name: '互联网金融',
    children: ['综合管理', '互金营销拓展', '互金技术运维'],
  },
  {
    name: '产品',
    children: ['产品设计'],
  },
]
const 证券公司 = [
  {
    name: '投资银行业务',
    children: [
      '投资银行综合管理',
      '项目承揽承做',
      '股权项目承揽承做',
      '结构化项目承揽承做',
      '并购融资/财务顾问项目承揽承做',
      '股权资本市场（ECM）',
      '质量控制',
    ],
  },
  {
    name: '固定收益业务',
    children: ['固定收益综合管理', '债券项目承揽承做', '债券投资与交易', '债券研究', '债务资本市场（DCM）', '质量控制'],
  },
  { name: '新三板业务', children: ['新三板综合管理', '新三板项目承揽承做', '新三板做市', '质量控制'] },
  {
    name: '资产管理业务',
    children: [
      '资管综合管理',
      '投资（资管）',
      '股票投资（资管）',
      '其他投资（资管）',
      '研究（资管）',
      '机构销售（资管）',
      '渠道销售 （资管）',
      '市场营销（资管）',
      '交易（资管）',
      '清算估值账户（资管）',
      '产品设计（资管）',
      '客户服务（资管）',
      '合规风控（资管）',
    ],
  },
  {
    name: '证券投资（自营）业务',
    children: [
      '自营综合管理',
      '权益投资（自营）',
      '衍生品投资（自营）',
      '量化投资（自营）',
      '另类投资（自营）',
      '研究（自营）',
      '交易（自营）',
      '合规风控（自营）',
    ],
  },
  { name: '研究所', children: ['研究所综合管理', '研究', '宏观/策略研究', '行业研究', '量化研究', '研究销售'] },
  { name: '机构业务', children: ['机构业务综合管理', '机构客户销售', '产品销售', '营销策划'] },
  {
    name: '零售业务',
    children: [
      '零售业务综合管理',
      '互联网金融运营',
      '产品销售管理',
      '营销团队建设与管理',
      '营销策划',
      '网点规划与建设',
      '客户服务',
      '财富管理',
      '投资咨询管理',
      '高净值客户服务',
      '个股期权',
      '分支机构管理',
      '产品设计',
    ],
  },
  { name: '信用交易业务', children: ['信用交易业务'] },
  { name: '国际业务', children: ['国际业务'] },
  { name: 'OTC柜台业务', children: ['OTC柜台业务'] },
  { name: '托管业务', children: ['托管业务'] },
  { name: '高管管理', children: ['高管'] },
  { name: '风控法务合规', children: ['风险管理'] },
  {
    name: '人力资源',
    children: [
      '法务',
      '合规',
      '稽核审计',
      '监察室',
      '管理',
      '招聘',
      '员工关系与发展',
      '薪酬规划与分析',
      '薪酬福利',
      '组织发展',
      '培训',
      '绩效考核',
      '干部管理',
      '档案管理',
      '系统管理',
    ],
  },
  {
    name: '行政管理',
    children: [
      '董事会办公室',
      '证券及投资',
      '战略规划与管理',
      '综合行政管理',
      '综合文秘管理',
      '前台',
      '司机',
      '资产管理',
      '营运管理',
      '基建办',
      '党工团',
    ],
  },
  {
    name: '财务管理',
    children: [
      '管理',
      '总账会计',
      '业务会计',
      '信息披露',
      '会计出纳',
      '核算会计',
      '费用审核',
      '财务信息化',
      '财务分析',
      '预算管理',
      '管理会计',
      '税务',
      '资金运营',
      '资金结算',
      '融资',
      '其他',
    ],
  },
  { name: '信息技术', children: ['管理', '开发', '运维'] },
  { name: '市场营销与品牌管理', children: ['市场营销', '品牌管理'] },
]
const 信托公司 = [
  { name: '总经理办公室', children: ['高管'] },
  {
    name: '资产管理',
    children: [
      '融资综合',
      '股权投资',
      '二级市场投资',
      '资产证券化',
      '资管项目事业部',
      '资管项目承揽',
      '行业研究',
      '资管项目承做',
    ],
  },
  { name: '财富中心', children: ['财富顾问', '产品管理'] },
  { name: '公司事务', children: ['战略规划', '行政管理', '注册事务', '公共关系'] },
  { name: '法务合规', children: ['法律'] },
  { name: '人力资源', children: ['人力', '招聘', '薪酬福利', '员工关系', '组织发展', '培训', '绩效考核'] },
  { name: '财务', children: ['财务', '资金', '会计', '审计', '税务'] },
  { name: '行政管理', children: ['秘书', '办公室助理', '党群/工会', '资料管理', '前台', '驾驶/运输'] },
  { name: '信息技术', children: ['技术', '软件开发', '计算机运行', '系统支持'] },
  { name: '市场部', children: ['市场营销'] },
  { name: '销售部', children: ['渠道销售', '销售支持'] },
  { name: '客服中心', children: ['客户服务', '金融产品设计'] },
  { name: '研究开发', children: ['金融产品设计'] },
  { name: '运营管理', children: ['运营', '交易', '投后管理', '信托财务', '数据分析', '资产保全'] },
  { name: '风险管理', children: ['风控'] },
]
const 保险资管 = [
  { name: '企业高管', children: ['高层管理'] },
  {
    name: '资产管理业务',
    children: [
      '资管综合管理',
      '投资（资管）',
      '股票投资（资管）',
      '债券投资（资管）',
      '其他投资（资管）',
      '研究（资管）',
      '机构销售（资管）',
      '渠道销售 （资管）',
      '市场营销（资管）',
      '交易（资管）',
      '清算估值账户（资管）',
      '产品设计（资管）',
      '客户服务（资管）',
      '合规风控（资管）',
      '运营',
    ],
  },
  { name: '法律风控', children: ['法务', '风控', '合规', '内控'] },
  { name: '人力资源', children: ['管理', '绩效', '组织发展', '薪酬福利', '员工关系', '培训', '招聘'] },
  { name: '行政管理', children: ['行政', '文秘', '资产管理', '采购类'] },
  { name: '财务会计类', children: ['财务综合管理', '会计核算', '财务管理', '税务', '资金管理'] },
  { name: '信息技术', children: ['技术', '软件开发', '计算机运行', '系统支持'] },
]
const 商业银行 = [
  { name: '企业高管', children: ['高层管理'] },
  {
    name: '前台业务',
    children: ['综合管理', '公司银行业务', '个人银行业务', '中间业务', '资金外汇业务', '互联网金融'],
  },
  { name: '法律风控', children: ['法务', '风控', '合规', '内控'] },
  { name: '人力资源', children: ['管理', '绩效', '组织发展', '薪酬福利', '员工关系', '培训'] },
  { name: '行政管理', children: ['行政', '文秘', '资产管理', '采购类'] },
  { name: '财务会计类', children: ['财务综合管理', '会计核算', '财务管理', '税务', '资金管理'] },
  { name: '信息技术', children: ['技术', '软件开发', '计算机运行', '系统支持'] },
]
const PEVC = [
  { name: '不动产投资', children: ['不动产研究和收购', '不动产投资组合管理'] },
  { name: '财务', children: ['财务', '会计'] },
  { name: '法务', children: ['法务'] },
  { name: '风险管理', children: ['风控'] },
  { name: '高级管理', children: ['高管'] },
  {
    name: '股权投资',
    children: ['股权关系管理', '私募股权基金管理', '私募股权投资组合管理', '并购', '并购', '投后管理'],
  },
  { name: '固定收益', children: ['固收投资'] },
  { name: '行政管理', children: ['公司事务', '行政', '文秘', '运输服务'] },
  { name: '人力资源', children: ['人力', '薪酬福利', '招聘', '培训', '员工关系', '组织发展', '绩效考核'] },
  { name: '市场', children: ['销售支持', '市场营销', '公关'] },
  { name: '信息技术', children: ['信息技术开发', '运维管理'] },
  { name: '研究', children: ['资产管理研究', '战略研究'] },
]
export { 公募基金, 证券公司, 信托公司, 保险资管, 商业银行, PEVC }
